export default "__VITE_PUBLIC_ASSET__a5bee671__"